(() => {
  'use strict';
  if (window.Habicat) return;
  document.documentElement.classList.replace('no-js', 'js');
  const config = JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}');
  const root = config.root || '/';
  const strings = config.strings || {};
  const money = cents => new Intl.NumberFormat(config.locale || 'it', { style: 'currency', currency: config.currency || 'EUR' }).format(Number(cents) / 100);
  const announce = text => { const status = document.getElementById('GlobalStatus'); if (status) status.textContent = text; };
  const parseHTML = html => new DOMParser().parseFromString(html, 'text/html');
  let cartBusy = false;
  let opener = null;
  function openCart(trigger) {
    const dialog = document.getElementById('CartDrawer');
    if (!dialog || typeof dialog.showModal !== 'function') { location.assign(config.cart || root + 'cart'); return; }
    opener = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-dialog-close]')?.focus();
  }
  function closeCart() {
    document.getElementById('CartDrawer')?.close();
    document.documentElement.style.overflow = '';
    if (opener?.isConnected) opener.focus();
  }
  function cartSections() {
    const result = ['cart-drawer'];
    const page = document.querySelector('[data-cart-page]');
    if (page?.dataset.sectionId) result.push(page.dataset.sectionId);
    return result;
  }
  function updateCart(sections) {
    let drawerUpdated = false;
    const activeKey = document.activeElement?.dataset?.focusKey;
    for (const html of Object.values(sections || {})) {
      if (typeof html !== 'string') continue;
      const doc = parseHTML(html);
      const next = doc.querySelector('[data-cart-content]');
      const current = document.querySelector('[data-cart-content]');
      if (next && current) {
        current.replaceChildren(...next.childNodes);
        current.dataset.itemCount = next.dataset.itemCount;
        document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = next.dataset.itemCount; });
        drawerUpdated = true;
      }
      const page = doc.querySelector('[data-cart-page-content]');
      const existing = document.querySelector('[data-cart-page-content]');
      if (page && existing) existing.replaceChildren(...page.childNodes);
    }
    if (activeKey) [...document.querySelectorAll('[data-focus-key]')].find(node => node.dataset.focusKey === activeKey)?.focus();
    return drawerUpdated;
  }
  async function refreshCart() {
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('sections', cartSections().join(','));
    const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(strings.error);
    if (!updateCart(await response.json())) throw new Error(strings.refreshError || strings.error);
  }
  async function getCart() {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(strings.error);
    return response.json();
  }
  function cartError(text) {
    document.querySelectorAll('[data-cart-error]').forEach(node => { node.textContent = text || ''; node.hidden = !text; });
  }
  async function mutateCart(endpoint, payload, options = {}) {
    if (cartBusy) throw new Error(strings.error);
    cartBusy = true;
    document.body.classList.add('is-cart-busy');
    document.querySelectorAll('[data-cart-page],#CartDrawer').forEach(node => node.setAttribute('aria-busy', 'true'));
    cartError('');
    let succeeded = false;
    try {
      const response = await fetch(endpoint + '.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections: cartSections(), sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok) {
        try { await refreshCart(); } catch (_) {}
        throw new Error(typeof result.description === 'string' ? result.description : strings.error);
      }
      succeeded = true;
      if (!updateCart(result.sections)) await refreshCart();
      announce(options.add ? strings.added : strings.updated);
      if (options.open) openCart(options.trigger);
      return result;
    } catch (error) {
      if (succeeded) {
        cartError(strings.refreshError);
        if (options.open) location.assign(config.cart || root + 'cart');
        return { added: true, refreshFailed: true };
      }
      throw error;
    } finally {
      cartBusy = false;
      document.body.classList.remove('is-cart-busy');
      document.querySelectorAll('[data-cart-page],#CartDrawer').forEach(node => node.removeAttribute('aria-busy'));
    }
  }
  window.Habicat = { config, money, announce, parseHTML, openCart, getCart, refreshCart, mutateCart };
  document.addEventListener('click', async event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-cart-open]') && config.drawer) { event.preventDefault(); openCart(target); return; }
    if (target.matches('[data-dialog-close]')) { closeCart(); return; }
    const remove = target.dataset.cartRemove || target.dataset.cartExtraRemove;
    const step = target.dataset.cartStep;
    const extra = target.hasAttribute('data-cart-extra-add');
    if (remove || step || extra) {
      event.preventDefault();
      if (cartBusy) return;
      try {
        if (extra) {
          const select = target.closest('.cart-extra').querySelector('[data-cart-extra-select]');
          await mutateCart(config.add, { items: [{ id: Number(select.value), quantity: 1 }] }, { add: true });
        } else {
          const input = target.closest('[data-cart-line]')?.querySelector('[data-cart-quantity]');
          const quantity = remove ? 0 : Math.max(0, Number(input.value) + Number(step) * Number(input.step || 1));
          await mutateCart(config.change, { id: remove || target.dataset.key, quantity });
        }
      } catch (error) { cartError(error.message || strings.error); }
      return;
    }
    if (target.matches('[data-carousel-prev],[data-carousel-next]')) {
      const track = target.closest('.section-space').querySelector('[data-carousel-track]');
      if (track?.firstElementChild) track.scrollBy({ left: (target.hasAttribute('data-carousel-prev') ? -1 : 1) * (track.firstElementChild.getBoundingClientRect().width + 12), behavior: 'smooth' });
    }
    if (target.matches('[data-product-link]')) {
      const product = document.querySelector('product-controller');
      if (product) { event.preventDefault(); product.scrollIntoView({ behavior: 'smooth' }); product.querySelector('input:not([type=hidden]),button')?.focus({ preventScroll: true }); }
    }
  });
  document.addEventListener('change', async event => {
    const input = event.target;
    if (input.matches('[data-cart-extra-select]')) {
      const price = input.closest('.cart-extra').querySelector('[data-extra-price]');
      const option = input.selectedOptions[0];
      if (price && option) {
        price.textContent = money(option.dataset.price);
        if (Number(option.dataset.compare) > Number(option.dataset.price)) { const was = document.createElement('s'); was.textContent = money(option.dataset.compare); price.append(' ', was); }
      }
    }
    if (input.matches('[data-cart-quantity]')) {
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0 || !input.checkValidity()) { input.reportValidity(); return; }
      if (cartBusy) return;
      try { await mutateCart(config.change, { id: input.dataset.key, quantity }); }
      catch (error) { cartError(error.message || strings.error); }
    }
    if (input.matches('[data-cart-note]')) {
      try { await mutateCart(config.update, { note: input.value }); }
      catch (error) { cartError(error.message || strings.error); }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header-menu[open],.info-popover[open],.drawer-info[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.header-menu[open],.info-popover[open],.drawer-info[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
    const drawer = document.getElementById('CartDrawer');
    if (event.target === drawer) {
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeCart();
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('#DrawerCartForm,#PageCartForm') && cartBusy) event.preventDefault();
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-tracking-form]');
    if (!form) return;
    event.preventDefault();
    const field = form.querySelector('[name="tracking"]');
    const code = field.value.trim().replace(/\s+/g, '');
    if (!code) { field.focus(); return; }
    window.open('https://t.17track.net/it#nums=' + encodeURIComponent(code), '_blank', 'noopener,noreferrer');
  });
  const drawers = new WeakSet();
  const reviewInstances = new WeakMap();
  const videoObservers = new WeakMap();
  function init(scope = document) {
    const drawer = scope.querySelector('#CartDrawer');
    if (drawer && !drawers.has(drawer)) {
      drawers.add(drawer);
      drawer.addEventListener('close', () => { document.documentElement.style.overflow = ''; if (opener?.isConnected) opener.focus(); });
    }
    scope.querySelectorAll('[data-reviews]').forEach(container => {
      if (reviewInstances.has(container)) return;
      const cards = [...container.querySelectorAll('[data-review]')];
      const nav = container.querySelector('[data-review-pagination]');
      const size = Number(container.dataset.pageSize) || 8;
      const pages = Math.ceil(cards.length / size);
      function show(page, scroll = false) {
        cards.forEach((card, i) => { card.hidden = Math.floor(i / size) !== page; });
        nav.querySelectorAll('button').forEach((button, i) => { if (i === page) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current'); });
        if (scroll) container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      if (nav && pages > 1) for (let i = 0; i < pages; i++) {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = String(i + 1);
        button.addEventListener('click', () => show(i, true)); nav.append(button);
      }
      if (nav) show(0);
      reviewInstances.set(container, { show, cards, size });
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    scope.querySelectorAll('[data-ambient-video]').forEach(video => {
      video.controls = false; video.muted = true; video.playsInline = true;
      video.tabIndex = -1;
      video.removeAttribute('role'); video.removeAttribute('aria-pressed');
      video.disablePictureInPicture = true; video.disableRemotePlayback = true;
      if (reduced || videoObservers.has(video)) return;
      if (!('IntersectionObserver' in window)) { video.play().catch(() => {}); return; }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) video.play().catch(() => {}); else video.pause();
      }), { threshold: .25 });
      observer.observe(video); videoObservers.set(video, observer);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => {
    init(event.target);
    if (event.target.querySelector('product-controller') && !customElements.get('product-controller')) {
      const script = event.target.querySelector('script[src*="product.js"]');
      if (script) { const loader = document.createElement('script'); loader.src = script.src; loader.defer = true; document.head.append(loader); }
    }
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ambient-video]').forEach(video => { videoObservers.get(video)?.disconnect(); videoObservers.delete(video); video.pause(); });
    if (event.target.querySelector('#CartDrawer[open]')) document.documentElement.style.overflow = '';
  });
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-review]');
    if (card) {
      const state = reviewInstances.get(card.closest('[data-reviews]'));
      if (state) state.show(Math.floor(state.cards.indexOf(card) / state.size));
    }
    event.target.closest('details')?.setAttribute('open', '');
    if (event.target.closest('.cat-card')) event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();
